import Form from './Form';
export default Form;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/form/index.js
// module id = 789
// module chunks = 3